import {
    ADJUSTMENTS_REASONS_FETCH,
    ADJUSTMENTS_REASONS_FETCH_ALL,
    ADJUSTMENTS_REASONS_IS_FETCING,
    ADJUSTMENTS_REASONS_API,
    ADJUSTMENT_REASONS_EDIT,
    ADJUSTMENT_REASONS_FILTER,
    UPDATE_ADJUSTMENT_REASONS_STATUS
} from 'constants/adjustmentsReasons'

//HTTP reuests actions
import {
    put,
    post,
    remove,
    get
} from 'actions/requests'

export const adjustmentReasonsSave = (data) => (dispatch, state) => {
    let action;
    if (data.adjustmentId)
        action = put;
    else
        action = post;
    dispatch(adjustmentsReasonsIsFetching(true))
    return action(ADJUSTMENTS_REASONS_API, data)
        .then((e) => { dispatch(adjustmentsReasonsIsFetching(false)); return e; })
        .catch((e) => { dispatch(adjustmentsReasonsIsFetching(false)); throw new Error(e) })
}

export const adjustmentsReasonsFetch = () => (dispatch, state) => {
    dispatch(adjustmentsReasonsIsFetching(true));
    const filter = state().adjustmentsReasons.pageable
    const sorted = Object.keys(filter.sort).find(e => filter.sort[e])
    return get(ADJUSTMENTS_REASONS_API, {
            size: filter.size,
            page: filter.page,
            sort: sorted + ',' + filter.sort[sorted]
        })
        .then((e) => {
            dispatch(adjustmentsReasonsFetched(e.content))
            return e
        })
        .then((e) => {
            dispatch(
                adjustmentReasonsFilter({
                    totalPages: e.totalPages
                })
            )
            return e
        })
        //disable loading
        .finally(e => dispatch(adjustmentsReasonsIsFetching(false)))
}


export const adjustmentsReasonsFetchAll = () => (dispatch, state) => {
    dispatch(adjustmentsReasonsIsFetching(true));
    return get(ADJUSTMENTS_REASONS_API,{})
        .then((e) => {
            dispatch(adjustmentsReasonsFetchedAll(e.content))
            return e
        })
        //disable loading
        .finally(e => dispatch(adjustmentsReasonsIsFetching(false)))
}

export const declineAdjustmentReasons = (id) => (dispatch, state) => {
	dispatch(adjustmentsReasonsIsFetching(true))
    return post(ADJUSTMENTS_REASONS_API + '/decline/' + id)
            .then((data) => dispatch(updateAdjustmentReasonsStatus(data)))
			.finally(e => dispatch(adjustmentsReasonsIsFetching(false)))
}

export const approveAdjustmentReasons = (id) => (dispatch, state) => {
	dispatch(adjustmentsReasonsIsFetching(true))
    return post(ADJUSTMENTS_REASONS_API + '/approve/' + id)
            .then((data) => dispatch(updateAdjustmentReasonsStatus(data)))
			.finally(e => dispatch(adjustmentsReasonsIsFetching(false)))
}

export const adjustmentReasonsRemove = (id) => (dispatch, state) => {
    dispatch(adjustmentsReasonsIsFetching(true))
    return remove(ADJUSTMENTS_REASONS_API + '/' + id)
        .finally(e => dispatch(adjustmentsReasonsIsFetching(false)))
}
export const adjustmentsReasonsFetched = (payload) => ({ type: ADJUSTMENTS_REASONS_FETCH, payload: payload })
export const adjustmentsReasonsFetchedAll = (payload) => ({ type: ADJUSTMENTS_REASONS_FETCH_ALL, payload: payload })
export const adjustmentsReasonsIsFetching = (payload) => ({ type: ADJUSTMENTS_REASONS_IS_FETCING, payload: payload })
export const adjustmentReasonsEdit = (id, data) => ({ type: ADJUSTMENT_REASONS_EDIT, payload: data })
export const adjustmentReasonsFilter = (data) => ({ type: ADJUSTMENT_REASONS_FILTER, payload: data })
export const updateAdjustmentReasonsStatus = (data) => ({type: UPDATE_ADJUSTMENT_REASONS_STATUS, payload: data})


// WEBPACK FOOTER //
// ./src/actions/adjustmentsReasons.js